// Generated by scripts/observability-contracts.ts. Edit the canonical page catalogs.
export { PAGE_CONTENT_CONTRACTS } from './page-contracts.runtime.generated'
